import input from './input';
import button from './button';

export default {
  input,
  button,
};
